import { createContext, useContext } from 'react'

import type { FlowQuery, PaymentSubjectInput } from '@twisto/api-graphql'

/**
 * Context
 */

export type FlowContextType = {
  flow: NonNullable<FlowQuery['flow']>
  sessionId: string
  actions: {
    handleClose?: () => void
    triggerPaymentIntent?: (paymentSubject: PaymentSubjectInput) => void
  }
}

export const FlowContext = createContext<null | FlowContextType>(null)

/**
 * Hook
 */

type Steps = NonNullable<FlowQuery['flow']>['currentStep']
type StepTypename = Steps['__typename']

export const useFlow = <Step extends StepTypename>() => {
  const context = useContext(FlowContext)

  if (!context) {
    throw new Error('useFlow must be used within a FlowProvider')
  }

  // Add type based on passed generic
  const currentStep = context.flow.currentStep as Extract<
    Steps,
    { __typename: Step }
  >

  return {
    ...context,
    flow: {
      ...context.flow,
      currentStep,
    },
  }
}
